import React from 'react';
import { css } from 'styled-components';
import AsyncSelect from 'react-select-v3/async';
import ReactSelect, { components } from 'react-select-v3';
import { reactSelectStyles } from 'utils/style';

const selectStyles = css`
  height: 32px;
  .dropdown {
    &:before {
      position: absolute;
      content: '';
      display: block;
      width: 0;
      height: 0;
      right: 8px;
      top: 50%;
      margin-top: -2px;
      border-style: solid;
      border-width: 4px 3px 0 3px;
      border-color: var(--grey500) transparent transparent transparent;
    }
  }
`;

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <div className="dropdown"></div>
    </components.DropdownIndicator>
  );
};

const Select = (props) => {
  const { components = {}, ...rest } = props || {};

  const SelectComponent = props.async ? AsyncSelect : ReactSelect;

  return (
    <SelectComponent
      components={{ ...components, DropdownIndicator }}
      styles={reactSelectStyles}
      {...rest}
    />
  );
};

export { Select, selectStyles };
